import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';
import {
  datePipe,
  filterZeroValuesForChart,
  filterZeroImpactIndicators,
  getRandomColorWithOpacity,
  wrapLabel,
  yAxisformateValue,
} from '@piqet-angular/data';
import { commonEnum } from '@piqet-angular/shared';
import { bottom } from '@popperjs/core';
import { Chart, ChartOptions } from 'chart.js';
import { reportTitals } from 'libs/shared/src/lib/reportConstant';
export interface Process {
  name: string;
  description: string;
  isIncluded?: boolean;
}
@Component({
  selector: 'piqet-angular-iso-report',
  templateUrl: './iso-report.component.html',
  styleUrls: ['./iso-report.component.scss'],
})
export class IsoReportComponent implements AfterViewInit {
  chartOpacity: any = { value: commonEnum.opacity };
  indicatorsName: string = '';
  generatedChartType: string = 'column';

  @Input() reportData: any;
  isTocVisible = false;
  tocSections: any = [];
  reviewColorList: any = [];
  piqetLogo = './assets/images/Piqet_NewLogo.svg';
  staticDate = new Date();
  reportResource = reportTitals;
  commonData: any = [];
  introductionData: any = [];
  goalAndScope: any = [];
  showHideSection: any = [];
  indicatorList: any = [];
  dataQualityAssessmentList: any = [];
  includeProcessHideShow: any;
  spiderChartItemsData: any;
  imagelist: any;
  indicatornamelist: any;
  indicatorunitnamelist: any;
  spiderChartData: any = [];
  spiderChartLabels: string[] = [];
  chartImage: any;
  componentItemsArray: any;
  componentItemsArrayForChart: any[] = [];
  componentItemsArrayISOreport: any;
  componentItems: any;
  componentItemsBArChart: any;
  lifeCycleImpactTableId: any;
  parentArr: any;
  parentArrIso: any;
  includeProcessHideShowDetailModel: any;
  isHideSensitivityAnalysis: boolean = false;
  isHideDataInterpretation: boolean = false;

  ratings = [
    { color: 'rgb(255, 46, 52)', title: 'Poor', value: 4 },
    { color: 'rgb(255, 155, 20)', title: 'Fair', value: 3 },
    { color: 'rgb(20, 232, 5)', title: 'Good', value: 2 },
    { color: 'rgb(5, 232, 250)', title: 'Very good', value: 1 },
  ];
  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;

  public barChartData: any = [];
  tableIndexList: any = [];
  figureIndexList: any = [];
  getCurrentYear: number = new Date().getFullYear();
  processes: { [key: string]: Process } = {
    isMaterial: {
      name: 'Materials',
      description:
        'Raw materials extraction, processing and manufacturing into finished materials used in packaging.',
    },
    isConversion: {
      name: 'Conversion',
      description:
        'The transportation of materials to the Converter and their subsequent transformation into packaging components.',
    },
    isFilling: {
      name: 'Filling',
      description:
        'The transportation of the packaging components to the Filler and the incorporation of contents into its packaging. This includes filling, sealing and preparing the packaged product for distribution.',
    },
    isWholesale: {
      name: 'Wholesale',
      description: 'The transportation of the package from Filling to, and storage at, Wholesale.',
    },
    isRetail: {
      name: 'Retail',
      description: 'The transportation and storage of the package from Wholesale to Retail.',
    },
    isConsumer: {
      name: 'Consumer',
      description:
        'The transportation of the package from Retail to, and storage at, the Consumer.',
    },
    isFullProductImpacts: {
      name: 'Product mass included in transport calculations',
      description:
        'The environmental impact associated with the production and processing of the actual product contained within the packaging.',
    },
    isProductLoss: {
      name: 'Product loss',
      description:
        'The impact of manufacturing and disposing of product at filling, wholesale, retail or consumer stage.',
    },
    isProductMassIncluded: {
      name: 'Full product impacts',
      description:
        'The mass of product is accounted for in the calculations of the logistics impacts throughout the supply chain. If not selected, the empty packaging mass is calculated instead.',
    },
    isEOL: {
      name: 'End-of-life',
      description:
        'The environmental considerations related to the disposal or recycling of the packaging, encompassing waste management, recycling processes, and potential environmental impact.',
    },
  };
  equevalancyTableId!: number;
  climatemateImpactFigureId!: number;
  sensitivityAnalysis: any = [];
  scenarioImages: any = [];
  qualityTableId!: number;
  categoryDefTableId!: number;
  wasterMaterialTableId!: number;
  allcationFactorTableId!: number;
  impactCategoryDefinationId!: number;
  materialList: any[] = [];
  isIncludedProcessExist: boolean = false;
  isExcludedProcessExist: boolean = false;
  isIncludedPackagingExist: boolean = false;
  isExcludedPackagingExist: boolean = false;
  reviewerOrganizationNames: any;
  reviewerOrganizationCountries: any;
  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.commonData = this.reportData?.common;
    this.isHideSensitivityAnalysis = this.reportData?.isSensitivityAnalysisRights;
    this.isHideDataInterpretation = this.reportData?.isInterpretationRights;
    this.scenarioImages = this.reportData?.common?.scenarioImages;
    this.introductionData = this.reportData?.introduction;
    this.goalAndScope = this.reportData?.goalAndScope;
    this.includeProcessHideShowDetailModel =
      this.reportData?.goalAndScope?.includeProcessHideShowDetailModel;
    this.isIncludedProcessExist = this.includeProcessHideShowDetailModel.some(
      (x: any) => x.selected && x.flag
    );
    this.isExcludedProcessExist = this.includeProcessHideShowDetailModel.some(
      (x: any) => !x.selected && x.flag
    );
    this.isIncludedPackagingExist = this.includeProcessHideShowDetailModel.some(
      (x: any) => x.selected && !x.flag
    );
    this.isExcludedPackagingExist = this.includeProcessHideShowDetailModel.some(
      (x: any) => !x.selected && !x.flag
    );
    this.sensitivityAnalysis = this.reportData?.sensitivityAnalysis;
    this.includeProcessHideShow = this.reportData?.goalAndScope?.includeProcessHideShowViewModel;
    this.showHideSection = this.reportData?.showHideSection;
    this.spiderChartItemsData = this.reportData?.spiderChartItems;
    this.dataQualityAssessmentList = this.reportData.interpretation?.dataQualityAssessmentList;
    this.materialList =
      this.reportData.interpretation?.dataQualityAssessmentList?.dataQualityAssessmentData;
    this.reviewColorList = this.reportData.interpretation?.dataQualityAssessmentList?.ratings;
    this.indicatorList = this.reportData?.goalAndScope?.indicatorList;
    this.imagelist = !!this.spiderChartItemsData?.scenarioListForAnnumImpact[0]
      ?.indicatorImageNameTable
      ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicatorImageNameTable.split(';')
      : [];
    this.indicatornamelist = !!this.spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators
      ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicators.split(';')
      : [];
    this.indicatorunitnamelist = !!this.spiderChartItemsData?.scenarioListForAnnumImpact[0]
      ?.indicatorUnitName
      ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicatorUnitName.split(';')
      : [];
    this.chartOpacity = { value: this.spiderChartItemsData?.opacity };
    // spider chart
    this.componentItemsArray = this.spiderChartItemsData?.scenarioList;
    this.componentItemsArrayForChart = filterZeroValuesForChart(
      this.componentItemsArray,
      'normalizedValue'
    );
    // bar chart
    const componentItemsArrayISOreport = this.spiderChartItemsData?.scenarioList.map((x: any) => {
      return {
        ...x,
        impactValues: x.normalizedValue,
        name: x.scenarioname,
      };
    });

    this.componentItemsArrayISOreport = filterZeroImpactIndicators(componentItemsArrayISOreport);
    this.indicatorsName = this.spiderChartItemsData?.indicatorName;
    this.tocSections = this.getFilteredTocSections();
    this.cd.detectChanges();
  }

  getFilteredTocSections() {
    const sections = [
      {
        id: 'introduction',
        title: '1. Introduction',
        children: [
          {
            id: 'criticalReview',
            title: '1.1 Critical review considerations',
          },
        ],
      },

      {
        id: 'goalAndScope',
        title: '2. Goal and scope',
        children: [
          { id: 'goal', title: '2.1 Goal' },
          { id: 'functionalUnit', title: '2.2 Functional unit' },
          { id: 'systemBoundaries', title: '2.3 System boundaries' },
          { id: 'multiFunctionality', title: '2.4 Multi-functionality' },
          {
            id: 'approachToBiogenicCarbonDesc',
            title: '2.5 Approach to biogenic carbon accounting',
          },
          { id: 'impactAssessmentCategory', title: '2.6 Impact assessment categories' },
          { id: 'dataQualityAssessment', title: '2.7 Data quality requirements' },
          { id: 'otherAssumption', title: '2.8 Other assumptions' },
        ],
      },
      {
        id: 'inventoryAnalysis',
        title: '3. Inventory analysis',
        children: [
          { id: 'foregroundData', title: '3.1 Foreground data' },
          { id: 'backgroundData', title: '3.2 Background data' },
        ],
      },
      {
        id: 'impactAssessmentResults',
        title: '4. Impact assessment results',
        children: [
          { id: 'resultSummaryCharacterization', title: '4.1 Result summary characterization' },
          { id: 'resultSummaryNormalized', title: '4.2 Result summary normalized' },
        ],
      },
      {
        id: 'interpretation',
        title: '5. Interpretation',
        children: [
          { id: 'contributionAnalysis', title: '5.1 Contribution analysis' },
          ...(this.isHideSensitivityAnalysis
            ? [{ id: 'sensitivityAnalysis', title: '5.2 Sensitivity analysis' }]
            : []),
          ...(this.isHideDataInterpretation
            ? [
                { id: 'uncertaintyAnalysisDescription', title: '5.3 Uncertainty analysis' },
                { id: 'dataQualityAssessment5', title: '5.4 Data quality assessment' },
                { id: 'pInterpretation', title: '5.5 Interpretation' },
              ]
            : []),
        ],
      },
      {
        id: 'conclusion',
        title: '6. Conclusion',
        children: [
          { id: 'limitationOfTheStudy', title: '6.1 Limitations of the study' },
          ...(this.isHideDataInterpretation
            ? [
                {
                  id: 'recommendationsAndConclusions',
                  title: '6.2 Recommendations and conclusions',
                },
              ]
            : []),
        ],
      },
    ];

    return sections;
  }

  ngAfterViewInit(): void {
    let elements = document.querySelectorAll('.uniqTableSeq');
    let elementsFigure = document.querySelectorAll('.uniqFigureSeq');
    let chartDesign = document.querySelectorAll('.chartDesign');
    let count = 1;
    let countFigure = 1;

    for (let i = 0; i < elementsFigure.length; i++) {
      const element = elementsFigure[i] as HTMLElement;
      let textContent = element.textContent || '';
      let innerHTML = element.innerHTML;
      let updatedHTML = innerHTML.replace(/#1/g, countFigure.toString());

      // IMPORTANT: Use a temporary div to handle HTML properly
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = updatedHTML;
      element.innerHTML = tempDiv.innerHTML;

      if (
        textContent.includes(
          ' Climate change comparison contribution by life cycle stage - per package'
        )
      ) {
        this.climatemateImpactFigureId = countFigure;
      }

      if (!textContent.includes('is shown')) {
        chartDesign[i]['id'] = countFigure - 1 + 'figureIndex';
        this.figureIndexList.push(element.textContent || '');
        countFigure++;
      }
    }

    for (let i = 0; i < elements.length; i++) {
      elements[i].id = i + 'tableIndex';
      const element = elements[i] as HTMLElement;
      let textContent = element.textContent || '';
      if (textContent.includes('Equivalence values')) {
        this.equevalancyTableId = count;
      }
      if (textContent.trim() === 'Table #1: Data quality assessment') {
        this.qualityTableId = count;
      }
      if (textContent.trim() === 'Table #1: Materials used in study and corresponding A Factors') {
        this.wasterMaterialTableId = count;
      }
      if (textContent.trim() === 'Table #1: Categories definition') {
        this.categoryDefTableId = count;
      }
      if (textContent.trim() === 'Table #1: Life cycle impacts - per package') {
        this.lifeCycleImpactTableId = count;
      }
      if (textContent.trim() === 'Table #1: Recycling allocation factors') {
        this.allcationFactorTableId = count;
      }
      if (textContent.trim() === 'Table #1: Impact categories definition') {
        this.impactCategoryDefinationId = count;
      }

      let innerHTML = element.innerHTML;
      let updatedHTML = innerHTML.replace(/#1/g, count.toString());
      element.innerHTML = updatedHTML;

      this.tableIndexList.push(element.textContent || '');
      count++;
    }
  }

  getRange(x: number): number[] {
    return Array.from({ length: x }, (_, index) => index);
  }

  getFormateDate(date: any) {
    return datePipe(date);
  }

  scrollToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset - 200;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  toggleToc(eve: any) {
    this.isTocVisible = !this.isTocVisible;
  }

  formatText(text: string): string {
    if (!text) return '';
    let formattedText = text.replace(/(?<!>)\n(?!\s*<)/g, '<br>');
    formattedText = formattedText.replace(/<\s*h[1-6]\b[^>]*>(.*?)<\s*\/\s*h[1-6]>/gi, '<p>$1</p>');
    return formattedText;
  }

  getScenarioComparisonText(): string {
    const list = this.commonData?.scenarioNameList ?? [];
    if (list.length === 0) return '';

    return (
      list
        .map((item: any, index: number) => {
          const reportDescription = item.reportDescription?.trim()
            ? item.reportDescription
            : item.scenarioName;
          const text = `the ${reportDescription} referred to as ${item.shortScenarioName}`;

          if (index === list.length - 2) return text + ', and ';
          if (index < list.length - 2) return text + ', ';
          return text;
        })
        .join('') + '.'
    );
  }

  getFormattedAuthors(): string {
    if (!this.commonData?.authorsInfoList || this.commonData.authorsInfoList.length === 0) {
      return '';
    }

    const formattedNames = this.commonData.authorsInfoList
      .map((a: any) => {
        const parts =
          a.userName
            ?.trim()
            .split(' ')
            .filter((p: string) => p.length > 0) || [];
        if (parts.length === 0) return '';

        const lastName = parts[parts.length - 1];
        const initials = parts
          .slice(0, -1)
          .map((p: string) => p.charAt(0).toUpperCase() + '.')
          .join(' ');

        return `${lastName}, ${initials}`;
      })
      .filter((name: string) => name.length > 0);

    return formattedNames.join(', ');
  }

  getFormattedReviewers(): string {
    if (!this.commonData?.reviewerInfoList || this.commonData.reviewerInfoList.length === 0) {
      return '';
    }

    const names: string[] = this.commonData.reviewerInfoList
      .map((r: any) => r.userName?.trim())
      .filter((name: string) => !!name);

    if (names.length === 1) return names[0];
    if (names.length === 2) return `${names[0]} and ${names[1]}`;

    return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
  }

  getFormattedOrganizationsWithoutCountry(): string {
    type ReviewerInfo = { organizationName: string; organizationCountry: string };
    const list: ReviewerInfo[] = this.commonData?.reviewerInfoList || [];

    const unique = Array.from(
      new Map<string, ReviewerInfo>(list.map(org => [org.organizationName, org])).values()
    );

    if (unique.length === 0) return '';
    if (unique.length === 1) return unique[0].organizationName;
    if (unique.length === 2) return unique.map(org => org.organizationName).join(' and ');

    const orgNames = unique.map(org => org.organizationName);
    const lastOrg = orgNames.pop();
    return `${orgNames.join(', ')} and ${lastOrg}`;
  }

  getFormattedCriticalReview(): string {
    const reviewers = this.getFormattedReviewers();
    const organizations = this.getFormattedOrganizationsWithoutCountry();

    if (reviewers && organizations) {
      return `A critical review was undertaken by ${reviewers} from ${organizations}.`;
    } else if (reviewers) {
      return `A critical review was undertaken by ${reviewers}.`;
    }
    return '';
  }

  getCitation(): string {
    const authors = this.getFormattedAuthors(); // now from authorsInfoList
    const year = new Date().getFullYear();
    const title = this.commonData?.projectName || 'Untitled Project';
    const scenario = this.commonData?.selectedScenarioName || '';
    const location = this.commonData?.selectedDefaultLocation || '';
    const organizations = this.getFormattedOrganizations(); // still works from reviewerInfoList

    let citation = authors ? `${authors}, (${year}), ${title}` : `${title}`;

    if (scenario && location) {
      citation += ` of ${scenario} in ${location}`;
    } else if (scenario) {
      citation += ` of ${scenario}`;
    } else if (location) {
      citation += ` in ${location}`;
    }

    if (organizations) {
      citation += `, ${organizations}`;
    }

    return citation;
  }
  getFormattedOrganizations(): string {
    type ReviewerInfo = { organizationName: string; organizationCountry: string };
    const list: ReviewerInfo[] = this.commonData?.authorsInfoList || [];

    const unique = Array.from(
      new Map<string, ReviewerInfo>(
        list.map((org: ReviewerInfo) => [`${org.organizationName},${org.organizationCountry}`, org])
      ).values()
    );

    if (unique.length === 0) {
      return '';
    }

    if (unique.length === 1) {
      return `${unique[0].organizationName}, ${unique[0].organizationCountry}`;
    }

    const countries = [...new Set(unique.map(org => org.organizationCountry))];

    if (countries.length === 1) {
      // All organizations are from the same country
      const orgNames = unique.map(org => org.organizationName);

      if (orgNames.length === 2) {
        return `${orgNames.join(' and ')}, ${countries[0]}`;
      } else {
        // 3 or more organizations
        const lastOrg = orgNames.pop();
        return `${orgNames.join(', ')}, and ${lastOrg}, ${countries[0]}`;
      }
    } else {
      // Organizations from different countries
      const formattedOrgs = unique.map(
        org => `${org.organizationName}, ${org.organizationCountry}`
      );

      if (formattedOrgs.length === 2) {
        return formattedOrgs.join(' and ');
      } else {
        // 3 or more organizations
        const lastOrg = formattedOrgs.pop();
        return formattedOrgs.join(', ') + ', and ' + lastOrg;
      }
    }
  }
}
